/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizzazioneResDto } from '../../models/organizzazione-res-dto';

export interface OrganizzazioniControllerGetOneOrganizzazioneById$Params {
  id: number;
}

export function organizzazioniControllerGetOneOrganizzazioneById(
  http: HttpClient,
  rootUrl: string,
  params: OrganizzazioniControllerGetOneOrganizzazioneById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrganizzazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    organizzazioniControllerGetOneOrganizzazioneById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrganizzazioneResDto>;
      }),
    );
}

organizzazioniControllerGetOneOrganizzazioneById.PATH =
  '/admin/organizzazioni/id/{id}';
